import { render, staticRenderFns } from "./confirm-email.vue?vue&type=template&id=c442d16c"
import script from "./confirm-email.vue?vue&type=script&lang=js"
export * from "./confirm-email.vue?vue&type=script&lang=js"
import style0 from "./confirm-email.vue?vue&type=style&index=0&id=c442d16c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c442d16c')) {
      api.createRecord('c442d16c', component.options)
    } else {
      api.reload('c442d16c', component.options)
    }
    module.hot.accept("./confirm-email.vue?vue&type=template&id=c442d16c", function () {
      api.rerender('c442d16c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/account/confirm-email.vue"
export default component.exports